import { getFeature } from 'Cloud/Application/FeaturesEs6';

// CLOUDWEB-19017
// Показ скидки/триала в растяжках/модалках (Облако)
const overquotaAbTariff: 'a' | 'b' | 'c' | 'd' | undefined = getFeature('overquota-ab-tariff');

export const overquotaAbTariffB = overquotaAbTariff === 'b';
export const overquotaAbTariffC = overquotaAbTariff === 'c';
export const overquotaAbTariffD = overquotaAbTariff === 'd';

export const overquotaAbTariffBC = overquotaAbTariffB || overquotaAbTariffC;
